/*
* OfferServicesReducer
*/

import { fromJS } from 'immutable';
import {
  GET_SERVICES,
  SERVICES_ERROR,
  SERVICES_RECEIVED,
  SERVICE_SELECTED,
  SET_OFFER_PRODUCT_SERVICES,
  RESET,
} from './constants';
import { SET_OFFER_PRODUCT } from '../OfferValue/constants'

// The initial state of the App
export const initialState = fromJS({
  services: [],
  selected: {},
  productServices: [],
  error: null,
  loading: false,
});

function offersReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SERVICES:
      return state.set('loading', true);
    case SERVICES_RECEIVED:
      return state.set('services', action.services).set('loading', false);
    case SERVICE_SELECTED:
      return state.set('selected', action.services);
    case SET_OFFER_PRODUCT_SERVICES:
      return state.set('productServices', action.services);
    case SET_OFFER_PRODUCT:
      return state.set('productServices', []).set('selected', []);
    case SERVICES_ERROR:
      return state
        .set('error', action.error)
        .set('services', [])
        .set('loading', false);
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default offersReducer;
